// extracted by mini-css-extract-plugin
module.exports = {"supply_depot_page":"SupplyDepotPage_supply_depot_page__2Valz","loading_screen":"SupplyDepotPage_loading_screen__qcRYH","loading_text":"SupplyDepotPage_loading_text__2LmqE"};